import React from 'react';
import PropTypes from 'prop-types';

import ListItem from './list_item';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export class ReorderableSingleList extends React.Component {
  static propTypes = {
    onReorder: PropTypes.func.isRequired,
    children: PropTypes.node,
    listClassName: PropTypes.string,
    itemClassName: PropTypes.string
  };

  render() {
    return (
      <ul className={this.props.listClassName}>
        {this.renderSections()}
      </ul>
    );
  }

  renderSections() {
    return this.props.children.map((Child, i) => {
      return (
        <ListItem
          index={i}
          listName="test"
          key={i}
          onReorder={this.props.onReorder}
          className={ this.props.itemClassName}
        >
          {Child}
        </ListItem>
      );
    });
  }
}

export default reorderableList(ReorderableSingleList);
